import React, { ChangeEvent, FC } from "react";
import { Field } from "react-final-form";
import { Checkbox } from "../../../components/Checkbox";
import { StyledCheckbox, StyledLabel } from "./index.styled";
import { HexColor } from "../../../types";
import { colors } from "../../../styles/variables";

interface FieldCheckboxProps {
  color?: HexColor;
  disabled?: boolean;
  fontSize?: string;
  label: string | JSX.Element;
  name: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const FieldCheckbox: FC<FieldCheckboxProps> = ({
  color,
  disabled = false,
  fontSize,
  label,
  name,
  onChange: customOnChange,
}) => (
  <Field
    type="checkbox"
    name={name}
    render={({ input: { onChange, checked } }) => (
      <StyledCheckbox>
        <StyledLabel
          textColor={disabled ? colors.gray500 : color}
          fontSize={fontSize}
        >
          <Checkbox
            checked={checked}
            onChange={(e) => {
              if (customOnChange) {
                customOnChange(e);
              }
              onChange(e);
            }}
            disabled={disabled}
          />
          {label}
        </StyledLabel>
      </StyledCheckbox>
    )}
  />
);
